import type { ListEmptyProps } from "./types";

export function ListEmpty({ children }: ListEmptyProps) {
  return (
    <div className="flex items-center justify-center py-12 text-secondary">
      {children}
    </div>
  );
}
